import template from './receipt.html';
import controller from './receipt.controller';

let receiptComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default receiptComponent;
